import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { CREATE_USER_GROUP_MEMBER_RESOURCE, USER_GROUP_MEMBERS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateUserGroupMemberService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_USER_GROUP_MEMBER_RESOURCE,
      method: 'post',
      request: (organisationId, userGroupId, body, t) => ({
        url: apiRoutes.userGroupMembers(organisationId, userGroupId),
        body,
        meta: {
          addToOtherList: {
            resource: USER_GROUP_MEMBERS_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createUserGroupMemberFailed'),
            onSuccessMessage: t('createUserGroupMemberSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateUserGroupMemberService;
